var _defs, _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.162,
    height: 33.941,
    viewBox: "0 0 33.162 33.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.844,
    y1: 0.151,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9ee60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3bafca"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b6bb20",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.581,
    cy: 16.97,
    rx: 16.581,
    ry: 16.97,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.581,
    cy: 16.97,
    rx: 15.581,
    ry: 15.97,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.247,28.491A14.245,14.245,0,0,1,4.173,4.173,14.246,14.246,0,0,1,24.319,24.319,14.153,14.153,0,0,1,14.247,28.491ZM15.453,4.3A9.943,9.943,0,0,0,14.7,24.158h.031c.253.019.489.028.721.028s.468-.009.722-.028h.014l.017,0A9.943,9.943,0,0,0,15.453,4.3Zm-6.479,16.3h0a9.08,9.08,0,1,1,12.96,0,8.858,8.858,0,0,0-2.3-1.065l-.009,0c-.9-.315-1.744-.613-1.979-1.133-.037-.443-.035-.783-.032-1.178v-.011l0-.169A4.2,4.2,0,0,0,18.65,15.2a1.653,1.653,0,0,0,.738-1.391,1.352,1.352,0,0,0-.243-.994c.236-.81.7-2.834-.117-4.143a2.263,2.263,0,0,0-1.546-1.04,2.614,2.614,0,0,0-2.075-.734,3.874,3.874,0,0,0-3.2,1.339c-.771,1.015-.917,2.551-.435,4.564a1.343,1.343,0,0,0-.254,1.009,1.652,1.652,0,0,0,.738,1.391,4.213,4.213,0,0,0,1.031,1.849v.177a11.7,11.7,0,0,1-.03,1.179c-.236.519-1.084.821-1.982,1.139l-.016.006a9.055,9.055,0,0,0-2.286,1.059Z",
    transform: "translate(4.671 4.754)",
    fill: "url(#a)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserContact);
export default __webpack_public_path__ + "static/media/user_contact.34054b38c468bc52226444ce5478545a.svg";
export { ForwardRef as ReactComponent };